import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedKeys: ['new_0101'],
    openKeys: ['new_0101'],
  },
  mutations: {
    SET_SELECTED_KEYS(state, keys) {
      state.selectedKeys = [keys]
    },
    SET_OPEN_KEYS(state, keys) {
      state.openKeys = [keys]
    },
  },
  getters: {
    hasPerm: (state) => (permCode) => {
        // const rolesa = JSON.parse(localStorage.getItem(process.env.VUE_APP_PERMISSIONS_KEY))
        // if (rolesa) {
        //     return rolesa.includes(permCode);
        // }
        // return false;
      return true
    },
  },
  actions: {
    setSelectedKeys (context, keys) {
      context.commit('SET_SELECTED_KEYS', keys)
    },
    setOpenKeys (context, keys) {
      context.commit('SET_OPEN_KEYS', keys)
    },
  },
  modules: {
  }
})
